import React from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import FormikDropdown from "../../components/inputFields/FormikDropDown";

const itemOptions = [
  { value: "item1", label: "Item 1" },
  { value: "item2", label: "Item 2" },
  { value: "item3", label: "Item 3" },
];
const statusOptions = [
  { value: "pending", label: "Pending" },
  { value: "approved", label: "Approved" },
  { value: "rejected", label: "Rejected" },
  { value: "completed", label: "Completed" },
];

const StatusReportSchema = Yup.object().shape({
  itemName: Yup.string().required("Required"),
  itemId: Yup.string().required("Required"),
  dateFrom: Yup.date().required("Required"),
  dateTo: Yup.date().required("Required"),
  statusType: Yup.string().required("Required"),
});

const StatusReportForm = () => {
  return (
    <>
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Status Report</h1>
        <p className="text-gray-600">Generate status reports for inventory items</p>
      </div>

      {/* Form Card */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <Formik
          initialValues={{
            itemName: "",
            itemId: "",
            dateFrom: "",
            dateTo: "",
            statusType: "",
          }}
          validationSchema={StatusReportSchema}
          onSubmit={(values) => {
            console.log("Status Report Submitted:", values);
          }}
        >
          {({ errors, touched }) => (
            <Form className="space-y-6">
              {/* Item Details Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <FormikDropdown
                  label="Item Name"
                  name="itemName"
                  options={itemOptions}
                  required
                  height={36}
                />
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Item ID/Code<span className="text-red-500 ml-1">*</span>
                  </label>
                  <Field
                    name="itemId"
                    className="w-full h-9 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="Enter Item ID or Code"
                  />
                  {touched.itemId && errors.itemId && (
                    <div className="text-red-500 text-xs mt-1">{errors.itemId}</div>
                  )}
                </div>
              </div>

              {/* Date Range Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    From Date<span className="text-red-500 ml-1">*</span>
                  </label>
                  <Field
                    name="dateFrom"
                    type="date"
                    className="w-full h-9 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  />
                  {touched.dateFrom && errors.dateFrom && (
                    <div className="text-red-500 text-xs mt-1">{errors.dateFrom}</div>
                  )}
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    To Date<span className="text-red-500 ml-1">*</span>
                  </label>
                  <Field
                    name="dateTo"
                    type="date"
                    className="w-full h-9 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  />
                  {touched.dateTo && errors.dateTo && (
                    <div className="text-red-500 text-xs mt-1">{errors.dateTo}</div>
                  )}
                </div>
              </div>

              {/* Status Type */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <FormikDropdown
                  label="Status Type"
                  name="statusType"
                  options={statusOptions}
                  required
                  height={36}
                />
                <div></div> {/* Empty div for grid alignment */}
              </div>

              {/* Submit Button */}
              <div className="flex justify-end pt-4 border-t border-gray-200">
                <button
                  type="submit"
                  className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-md text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                >
                  Generate Report
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default StatusReportForm; 